// extracted by mini-css-extract-plugin
export default {"forgotPasswordWrapper":"forgot-password_forgotPasswordWrapper__VpPs1","backButton":"forgot-password_backButton__vqsce"};